import { useTranslation } from "react-i18next";
import Select from "../Select";
import { hourTypes, type HourTypeSelectProps } from "./types";

function HourTypeSelect({ placeholder, ...props }: HourTypeSelectProps) {
    const { t } = useTranslation();

    return (
        <Select placeholder={placeholder ?? t("hour-type")} {...props}>
            {hourTypes.map((hourType) => (
                <Select.Item key={hourType} value={hourType}>
                    {t(hourType)}
                </Select.Item>
            ))}
        </Select>
    );
}

export default HourTypeSelect;
